import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ spacing }: Theme) => ({
  handlerRow: {
    marginBottom: spacing(2),
  },
}));
